export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <span className={`brand ${compact ? "brand--compact" : ""}`} aria-label="GoLightOps">
      <span className="brand__mark" aria-hidden="true">G<span>+</span></span>
      {compact ? null : <span className="brand__word">GoLight<span>Ops</span></span>}
    </span>
  );
}
